import MainController from '../../controllers/MainController';

const styles = theme => ({
  root: { height: MainController.showMobileVersion() ? 90 : 'inherit' },
  flexContainer: { height: MainController.showMobileVersion() ? 90 : 'inherit' },
});

export default styles;



// WEBPACK FOOTER //
// ./src/containers/routeTabs/RouteTabsStyles.js